export default "__VITE_ASSET__C82QYB1F__"